const availableTrackings = state => state.app.availableTrackings;
const hasGPDRConsent = state => state.app.hasGPDRConsent;
const isCookieDisclaimerOpened = state => state.app.cookieDisclaimer.opened;
const isAlternativeMode = state => state.app.isAlternativeMode;
const isIframe = state => state.app.isIframe;
const isInternal = state => state.app.isInternal;
const isCookiesEnabled = state => state.app.isCookiesEnabled;
const isLocalstorageAvailable = state => state.app.isLocalstorageAvailable;
const isLoading = state => state.app.isLoading;
const isReviewUse = state => state.app.isReviewUse;
const isOfflineMode = state => state.app.isOfflineMode;
const hasSidebar = state => state.app.hasSidebar;
const sidebarCollapsed = state => state.app.sidebarCollapsed;
const isOnline = state => state.app.isOnline;
const language = state => state.app.language;
const loadingBackground = state => state.app.loadingBackground;
const logos = state => state.app.logos;
const programInfo = state => state.app.programInfo;
const protocol = state => state.app.protocol;
const route = state => state.app.route;
const snackbar = state => state.app.snackbar;
const widget = state => state.app.widget;
const startedWidget = state => state.app.startedWidget;
const disableCloseSidebar = state => state.app.disableCloseSidebar;
const resolution = state => state.app.resolution;
const isFrontless = state => state.app.isFrontless;
const isOpenedNavbar = state => state.app.isOpenedNavbar;
const widgetTracking = state => state.app.widgetTracking;
const widgetTrackingEnabled = state => state.app.widgetTracking.enabled;
const currentWidgetTracking = state => state.app.widgetTracking.currentTracking;

export {
    availableTrackings,
    disableCloseSidebar,
    hasGPDRConsent,
    isAlternativeMode,
    isIframe,
    isInternal,
    isCookieDisclaimerOpened,
    isCookiesEnabled,
    isLocalstorageAvailable,
    isLoading,
    isOfflineMode,
    hasSidebar,
    sidebarCollapsed,
    isOnline,
    isReviewUse,
    language,
    logos,
    loadingBackground,
    programInfo,
    protocol,
    route,
    snackbar,
    widget,
    startedWidget,
    resolution,
    isFrontless,
    isOpenedNavbar,
    widgetTracking,
    widgetTrackingEnabled,
    currentWidgetTracking
};


// WEBPACK FOOTER //
// ./src/store/getters.js